import React from "react";
import ethos from "../static/data/ethos.js";
import "../sass/layout/_ourEthos.scss";

import LazyImage from "../components/LazyImage.js";
import AnimatedContent from "../animatedComponents/AnimatedContent.js";

export const OurEthos = () => {
  return (
    <AnimatedContent className="ethos-container">
      <h1>Our Ethos</h1>
      <div className="ethos-container-cards">
        {ethos.map((quality, index) => {
          return (
            <div key={index} className="ethos-column">
              <ul>
                <LazyImage
                  imgOnly={true}
                  src={quality.image}
                  alt={quality.heading}
                  className="ethos"
                  styleish={{ objectPosition: "bottom", objectFit: "cover" }}
                />
              </ul>
              <ul className="ethos-column-details">
                <li className="ethos-column-details-heading">
                  <h2>{quality.heading}</h2>
                </li>
                <li className="ethos-column-details-description">
                  <p>{quality.description}</p>
                </li>
              </ul>
            </div>
          );
        })}
      </div>

    </AnimatedContent>
  );
};
